import React from 'react';

import FieldString from '../../../components/plain/FieldString';
import FieldEnum from '../../../components/plain/FieldEnum';
import FieldDate from '../../../components/plain/FieldDate';
import FieldReference from '../../../components/plain/FieldReference';
import FieldList_Enum from '../../../components/plain/FieldList_Enum';

import { isUserSuperUser } from '../../../util/localStorage';
import { CLASS_PRODUCT, CLASS_PROVIDER } from '../../../util/consts/classes';
import { PRODUCT_PLAIN_PATH, PROVIDER_PLAIN_PATH } from '../../../util/routes';
import { FORM_PRODUCT_TABLE, FORM_PROVIDER_TABLE } from '../../../util/consts/forms';

class DivOfferPanel extends React.Component {

	/*
		plain
		instance
		fieldGroup
		listItemInfo
	*/
	constructor(props) {
		super(props);
	}

	render() {
		let readOnly = this.props.readOnly;
		let fieldGroup = this.props.fieldGroup;
		let plain = this.props.plain;
		let instance = this.props.instance;
		
		let productAndSupplierRefHtml = null;
		if( this.props.isPlain ) {
			productAndSupplierRefHtml = (
				<React.Fragment>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldReference instance={instance} path={'productRef'} parentField={fieldGroup} plain={plain} 
							readOnly={readOnly}
							styles={{ divMain: {flexGrow: '1'} }}
							refNodes={[
								{
									classId: CLASS_PRODUCT, plainFormPath: PRODUCT_PLAIN_PATH, 
									selectInstanceFormId: FORM_PRODUCT_TABLE,
									selectInstanceFormTitle: 'Продукти'
								},
							]}
						/>
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldReference instance={instance} path={'supplierRef'} parentField={fieldGroup} plain={plain} 
							readOnly={readOnly}
							styles={{ divMain: {flexGrow: '1'} }}
							refNodes={[
								{
									classId: CLASS_PROVIDER, plainFormPath: PROVIDER_PLAIN_PATH, 
									selectInstanceFormId: FORM_PROVIDER_TABLE,
									selectInstanceFormTitle: 'Постачальники'
								},
							]}
						/>
					</div>
				
				</React.Fragment>
			)
		}
		let bodyHtml = (
			<React.Fragment>
				{productAndSupplierRefHtml}
				<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
					<FieldEnum instance={instance} path={'state'} parentField={fieldGroup} plain={plain} 
						readOnly={readOnly}
						styles={{ select: {flexGrow: '1', marginRight: '20px'}}} 
					/>
					<FieldEnum instance={instance} path={'priceQualifier'} parentField={fieldGroup} plain={plain} 
						readOnly={readOnly}
						styles={{
							label: { divMain: {maxWidth: '130px'}}, 
							select: {flexGrow: '1', marginRight: '20px'}
						}} 
					/>
					<FieldString instance={instance} path={'delivery'} parentField={fieldGroup} plain={plain}
						readOnly={readOnly}
						styles={{ input: {flexGrow: '1'} }}
					/>
				</div>

				<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
					<FieldEnum instance={instance} path={'priceType'} parentField={fieldGroup} plain={plain} 
						readOnly={readOnly}
						styles={{ select: {flexGrow: '1', marginRight: '20px'}}} 
					/>
					<FieldString instance={instance} path={'price'} parentField={fieldGroup} plain={plain}
						readOnly={readOnly}
						styles={{ input: {flexGrow: '1', marginRight: '20px'} }}
					/>
					<FieldEnum instance={instance} path={'currencyCode'} parentField={fieldGroup} plain={plain} 
						readOnly={readOnly || ! isUserSuperUser() }
						styles={{ select: {flexGrow: '1'}}} 
					/>
				</div>

				<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
					<FieldString instance={instance} path={'minOrder'} parentField={fieldGroup} plain={plain}
						readOnly={readOnly}
						styles={{ input: {flexGrow: '1', marginRight: '20px'} }}
					/>
					<FieldDate instance={instance} path={'startDate'} parentField={fieldGroup} plain={plain} 
						readOnly={readOnly}
						styles={{ input: {flexGrow: '1', marginRight: '20px'}}} 
					/>
					<FieldDate instance={instance} path={'stopDate'} parentField={fieldGroup} plain={plain} 
						readOnly={readOnly}
						styles={{ input: {flexGrow: '1'}}} 
					/>
				</div>

				<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
					<FieldList_Enum
						instance={instance} path={'epubTP'} parentField={fieldGroup} plain={plain}
						labelEmptyToHeader={true}
						readOnly={readOnly}
						styles={{divMain: {flexGrow: '1'}}}
					/>
				</div>
			</React.Fragment>
		);
		if( this.props.isPlain ) {
			return <div>{bodyHtml}</div>;
		}
		return (
			<div style={{flexGrow: '1', backgroundColor: 'rgb(220,220,220)'}}>
				<div style={{margin: '10px', padding: '10px', border: '1px solid gray'}}>
					{bodyHtml}
				</div>
			</div>
		)
	}
}

export default DivOfferPanel;
